import { render } from "./NotificationsTableItem.vue?vue&type=template&id=2355397e&scoped=true"
import script from "./NotificationsTableItem.vue?vue&type=script&lang=js"
export * from "./NotificationsTableItem.vue?vue&type=script&lang=js"

import "./NotificationsTableItem.vue?vue&type=style&index=0&id=2355397e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2355397e"]])

export default __exports__